/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Colleague_FailedInputs */



/**
* | output |
* | --- |
* | "That colleague could not be added. Try again." |
*
* @param {Meetings_Colleague_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_colleague_failed = /** @type {((inputs?: Meetings_Colleague_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Colleague_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Die collega kon niet toegevoegd worden. Probeer het opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce collègue n'a pas pu être ajouté. Réessayez.")
	return /** @type {LocalizedString} */ ("That colleague could not be added. Try again.")
});